/** @jsxImportSource @emotion/react */
import { useTranslation } from 'react-i18next';
import { useMessageBar } from 'hooks/useMessageBar';
import CustomDialog from 'components/modals/common/CustomDialog';
import { IconButton } from 'components/buttons/IconSVG';
import { TableContainer, Table, TableBody, TableRow, TableCell, Button } from '@mui/material';
import { tb } from 'components/layouts/Table';
import CustomTextarea from 'components/inputs/CustomTextarea';
import { useEffect, useState } from 'react';

interface Props {
  open: boolean;
  close: () => void;
  onConfirm: () => void;
  commentValue?: string;
  onChangeComment?: (val: string) => void;
}

const IssueConfirmPopup = ({
  open,
  close,
  onConfirm,
  commentValue = '',
  onChangeComment,
}: Props) => {
  const { t } = useTranslation();
  const { openMessageBar } = useMessageBar();

  const [localValue, setLocalValue] = useState(commentValue);

  useEffect(() => setLocalValue(commentValue), [commentValue]);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const value = e.target.value;
    if (value.length <= 1000) {
      setLocalValue(value);
      onChangeComment?.(value);
    } else {
      openMessageBar({
        type: 'error',
        content: t(
          'setup.label.LGES Comment는 1000자를 넘을 수 없습니다.',
          'LGES Comment는 1000자를 넘을 수 없습니다.'
        ),
      });
    }
  };

  const dialogButtons = [
    <Button
      key="confirm"
      css={IconButton.button}
      className="confirm"
      onClick={onConfirm}
      disableRipple
    >
      {t('com.button.완료', '완료')}
    </Button>,
  ];

  return (
    <CustomDialog
      title={t('com.label.프로젝트 이슈 완료', '프로젝트 이슈 완료')}
      open={open}
      onClose={close}
      onCancel={close}
      buttons={dialogButtons}
    >
      <TableContainer css={tb.table}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>{t('setup.label.LGES Comment', 'LGES Comment')}</TableCell>
              <TableCell>
                <CustomTextarea
                  name="rvwRltCtn"
                  placeholder={String(
                    t('snsr.msg.LGES Comment를 입력해 주세요.', 'LGES Comment를 입력해 주세요.')
                  )}
                  style={{ height: '150px' }}
                  value={localValue}
                  onChange={handleChange}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </CustomDialog>
  );
};

export default IssueConfirmPopup;
